import React from 'react';
import { observer } from 'mobx-react';
import { Checkbox, Divider, Form } from 'antd';
import { useBytesPerKbSelectOptions, useCompanyInfo, useProfileIsRight } from '../../../hooks';
import { apiMessagesGetFormRules } from '../../../middleware';
import { tF } from '../../../translate';
import { Catcher, FormSelect } from '../../../Components';

// ToDo: 19.03.2026 -  add translate label
export const EditCompanyInfoTenantConfig: React.FC = observer(() => {
    const isRoot = useProfileIsRight('ROOT');
    const { isTenantConfig } = useCompanyInfo();

    return isRoot ? (
        <Catcher>
            <Form.Item
                name={'isTenantConfig'}
                valuePropName="checked"
                rules={apiMessagesGetFormRules}
                data-test={'EditCompanyInfoHideCostsData'}
            >
                <Checkbox data-test={'EditCompanyInfoTenantConfigEnableCheckBox'}>
                    {tF('Enable Tenant Config')}
                </Checkbox>
            </Form.Item>
            {isTenantConfig ? (
                <>
                    <Divider>{tF('Tenant config')}</Divider>
                    <FormSelect
                        dataTest={'EditCompanyInfoTenantConfigBytesPerKbData'}
                        fieldName={'bytesPerKb'}
                        isNotClear
                        isShortForm
                        label={tF('Multiplier for KB/MB/GB')}
                        required
                        rules={apiMessagesGetFormRules}
                        useSelectHook={useBytesPerKbSelectOptions}
                        disabled={!isTenantConfig}
                    />
                    <Form.Item
                        name={'hideCosts'}
                        valuePropName="checked"
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyInfoHideCostsData'}
                    >
                        <Checkbox data-test={'EditCompanyInfoTenantConfigHideCostsCheckBox'}>
                            {tF('Hide costs column for CDRs')}
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        name={'showPackageData'}
                        valuePropName="checked"
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyInfoTenantConfigShowPackageData'}
                    >
                        <Checkbox data-test={'EditCompanyInfoTenantConfigShowPackageDataCheckBox'}>
                            {tF('Show Product ID and Package Type in tariffs')}
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        name={'requireTariff'}
                        valuePropName="checked"
                        rules={apiMessagesGetFormRules}
                        data-test={'EditCompanyInfoTenantConfigShowPackageData'}
                    >
                        <Checkbox data-test={'EditCompanyInfoTenantConfigRequireTariffCheckBox'}>
                            {tF('Require tariff')}
                        </Checkbox>
                    </Form.Item>
                </>
            ) : null}
        </Catcher>
    ) : null;
});
